import { Check } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { BuyButton } from "@/components/Buttons";
import { SaleNote } from "@/components/SaleNote";
import { BUY } from "@/data/offer";

const PLANS = [
  {
    k: "teacher",
    t: "Nauczycielski",
    desc: "Dla nauczycielki, która rozwija własny warsztat.",
    price: "699 zł",
    to: "#nauczycielki",
    url: BUY.teacher1,
    items: ["Biblioteka nauczycielska: 14 kursów i e-booków", "1 dostęp", "12 miesięcy", "Certyfikaty uczestnictwa po kursach"],
  },
  {
    k: "owner",
    t: "Właścicielski",
    desc: "Dla właścicielki, która porządkuje i rozwija szkołę.",
    price: "1 499 zł",
    to: "#wlascicielki",
    url: BUY.owner,
    red: true,
    items: ["Biblioteka właścicielska: 6 kursów i e-booków", "1 dostęp właścicielki", "12 miesięcy", "Certyfikaty uczestnictwa po kursach"],
  },
  {
    k: "all",
    t: "Chcę mieć wszystko",
    desc: "Dla właścicielki, która rozwija szkołę i siebie jako nauczycielkę.",
    price: "1 999 zł",
    to: "#mam-wszystko",
    url: BUY.all,
    featured: true,
    items: ["Biblioteka nauczycielska: 14 kursów i e-booków", "Biblioteka właścicielska: 6 kursów i e-booków", "1 dostęp obejmujący obie biblioteki", "12 miesięcy", "Certyfikaty uczestnictwa po kursach"],
  },
];

export const Comparison = () => (
  <section data-testid="comparison-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <Reveal className="max-w-[720px]">
        <Eyebrow>Porównanie</Eyebrow>
        <h2 className="font-display mt-5 text-4xl font-medium leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl lg:text-6xl">
          Który abonament jest dla Ciebie?
        </h2>
      </Reveal>

      <div data-testid="comparison-table" className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-0 md:divide-x md:divide-ink/15 md:border md:border-ink/15">
        {PLANS.map((p, i) => {
          const dark = p.featured || p.red;
          const sub = p.featured ? "text-white/65" : p.red ? "text-white/80" : "text-ink/60";
          const rule = dark ? "border-white/20" : "border-ink/15";
          const label = dark ? "text-white/60" : "text-ink/50";
          const priceColor = p.red ? "text-white" : "text-red";
          const check = p.red ? "text-white" : "text-red";
          return (
          <Reveal key={p.k} delay={i * 0.08} className={`flex flex-col border border-ink/15 p-7 sm:p-9 md:border-0 ${p.featured ? "bg-ink text-white" : p.red ? "bg-red text-white" : "bg-white text-ink"}`}>
            <div data-testid={`comparison-card-${p.k}`} className="flex h-full flex-col">
              <h3 className="font-display text-3xl font-medium leading-tight sm:text-4xl">{p.t}</h3>
              <p className={`mt-3 text-[15px] leading-relaxed ${sub}`}>{p.desc}</p>
              <p className={`mt-7 border-t pt-6 ${rule}`}>
                <span className={`block text-[11px] font-semibold uppercase tracking-[0.2em] ${label}`}>Za rok</span>
                <span className={`font-display mt-1 block text-4xl leading-none sm:text-5xl ${priceColor}`}>
                  {p.price} <span className={`font-sans text-sm font-medium ${label}`}>/ rok</span>
                </span>
              </p>
              <ul className={`mt-7 flex-1 space-y-3 border-t pt-6 text-[15px] ${rule} ${dark ? "text-white/85" : "text-ink/75"}`}>
                {p.items.map((t) => (
                  <li key={t} className="flex gap-3">
                    <Check className={`mt-0.5 h-4 w-4 shrink-0 ${check}`} strokeWidth={2.5} />
                    {t}
                  </li>
                ))}
              </ul>
              <BuyButton href={p.url} variant={p.featured ? "red" : p.red ? "ink" : "outline"} testId={`comparison-cta-${p.k}`} className="mt-9 w-full">
                Kupuję abonament
              </BuyButton>
              <SaleNote dark={dark} />
            </div>
          </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
